import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "hydrometers";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const stripHydrometerIds = (hydrometer = {}) => {
  const { id, id_doc, idDoc, createdAt, updatedAt, deletedAt, ...payload } = hydrometer;
  return payload;
};

const HydrometersService = {
  findAll: async () =>
    apiService.get(ENDPOINT, {
      params: currentUserPayload(),
    }),

  findById: async (id) =>
    apiService.get(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      params: currentUserPayload(),
    }),

  create: async (hydrometer) =>
    apiService.post(ENDPOINT, {
      ...currentUserPayload(),
      ...stripHydrometerIds(hydrometer),
    }),

  update: async (id, hydrometer) =>
    apiService.put(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      ...currentUserPayload(),
      ...stripHydrometerIds(hydrometer),
    }),

  remove: async (id) =>
    apiService.delete(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      data: currentUserPayload(),
    }),
};

export default HydrometersService;
